import {combineReducers} from 'redux';

import type BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

import accidentIncidentReports from './accident-incident-reports/reducer';
import accountItems from './account-items/reducer';
import ageGroups from './age-groups/reducer';
import areas from './areas/reducer';
import billPayers from './bill-payers/reducer';
import children from './children/reducer';
import contacts from './contacts/reducer';
import credits, {type CreditsState} from './credits/reducer';
import discounts from './discounts/reducer';
import drafts from './drafts/reducer';
import employees from './employees/reducer';
import feed from './feed/reducer';
import groups from './groups/reducer';
import institutions from './institutions/reducer';
import institutionsPreview from './institutions-preview/reducer';
import meals from './meals/reducer';
import organizationPersons, {type OrganizationPersonsState} from './organization-persons/reducer';
import organizations from './organizations/reducer';
import paymentMethods from './payment-methods/reducer';
import plans from './plans/reducer';
import productBehaviors from './products/behaviors-reducer';
import products from './products/reducer';
import recipients from './recipients/reducer';
import recurringPaymentsBehaviors from './recurring-payments/behaviors-reducer';
import recurringPayments from './recurring-payments/reducer';
import reportLocations from './report-locations/reducer';
import roles from './roles/reducer';
import sessionBehaviors from './sessions/behaviors-reducer';
import sessions from './sessions/reducer';
import statuses from './statuses/reducer';
import surcharges, {type SurchargesState} from './surcharges/reducer';
import tags from './tags/reducer';

export interface EntitiesState {
    accidentIncidentReports: any;
    accountItems: any;
    ageGroups: any;
    areas: any;
    billPayers: any;
    children: any;
    contacts: any;
    credits: CreditsState;
    discounts: any;
    drafts: any;
    employees: any;
    feed: any;
    groups: any;
    institutions: any;
    institutionsPreview: any;
    meals: any;
    organizationPersons: OrganizationPersonsState;
    organizations: any;
    paymentMethods: any;
    productBehaviors: any;
    products: any;
    plans: any;
    recipients: any;
    recurringPayments: any;
    recurringPaymentsBehaviors: BehaviorsCollection;
    reportLocations: any;
    roles: any;
    sessions: any;
    sessionBehaviors: any;
    statuses: any;
    surcharges: SurchargesState;
    tags: any;
}

export default combineReducers<EntitiesState>({
    accidentIncidentReports,
    accountItems,
    ageGroups,
    areas,
    billPayers,
    children,
    contacts,
    credits,
    discounts,
    drafts,
    employees,
    feed,
    groups,
    institutions,
    institutionsPreview,
    meals,
    organizationPersons,
    organizations,
    paymentMethods,
    productBehaviors,
    products,
    plans,
    recipients,
    recurringPayments,
    recurringPaymentsBehaviors,
    reportLocations,
    roles,
    sessions,
    sessionBehaviors,
    statuses,
    surcharges,
    tags,
});
